import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { Controller, useFormContext } from 'react-hook-form';
import { Link } from 'react-router';

import { ManagePaymentMethods } from 'src/common/forms/PaymentMethodCaptureForm/ManagePaymentMethods';
import { BillingDetails } from 'src/common/forms/PaymentMethodCaptureForm/PaymentMethodCaptureForm';
import { useCanCapturePaymentMethod } from 'src/common/forms/PaymentMethodCaptureForm/useCanCapturePaymentMethod';

interface PassengerBillingFormProps {
  passengerId: string;
}

export function PassengerBillingForm({
  passengerId,
}: PassengerBillingFormProps) {
  const form = useFormContext<{ billing_details: BillingDetails }>();
  const {
    isEnabled: hasPaymentCaptureFeature,
    isLoading: isLoadingPaymentCaptureFeature,
  } = useCanCapturePaymentMethod();

  if (isLoadingPaymentCaptureFeature) {
    return <LoadingIndicator testId="loading-payment-capture" />;
  }

  if (!hasPaymentCaptureFeature) {
    return (
      <div>
        The Tilled payment integration isn't setup yet.{' '}
        <Link to="/billing/settings">Click here to get started.</Link>
      </div>
    );
  }

  return (
    <div className="mt-4 sm:col-span-6">
      <Controller
        name="billing_details"
        control={form.control}
        render={({ field }) => {
          return (
            <ManagePaymentMethods
              payerId={passengerId}
              payerType="passenger"
              billingName={field.value.billingName}
              onChangeBillingDetails={field.onChange}
            />
          );
        }}
      />
    </div>
  );
}
